module.exports = __webpack_public_path__ + "static/media/rub-out-the-words.e04d14dd.jpg";